import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import MediaViewer from '../../../../shared/media-viewer/MediaViewer';
import RedirectUrlLink from '../../../../shared/redirect-url-link/Redirect-Url-Link';
import CustomPhoneNoView from '../../../../shared/custom-PhoneNoView/CustomPhoneNoView';
import {
  allRestaurantSelector,
  allUIBuilderPagesSelector,
  allSpaInfoSelector,
  allCategoriesSelector,
  allAmenitiesSelector,
} from '../../../property/propertySlice';
import { allHouseKeeping, inRoomDiningMenuSelector } from '../../../services/servicesSlice';
import { isEmpty } from 'lodash';
import {
  CTA_CARD_PLACEMENT_MODULE_LIST,
  modulesWithoutSubModule,
} from '../../../../constants/OfferConst';
import { EMPTY_PLACEHOLDER, TIME_FORMAT_12_HOUR } from '../../../../utils/Constants';
import { formattedDetailsLabelData } from '../../../../utils/commonUtils';
import { offerSelector } from '../../cmsSlice';

const OfferCardDetails = ({ tabValue, offer }) => {
  const [image, setImage] = useState([]);
  const allRestaurants = useSelector(allRestaurantSelector);
  const allUIBuilderPages = useSelector(allUIBuilderPagesSelector);
  const inRoomDiningMenu = useSelector(inRoomDiningMenuSelector);
  const allSpaInfo = useSelector(allSpaInfoSelector);
  const allAccomodationCategories = useSelector(allCategoriesSelector);
  const allServiceRequestInfo = useSelector(allHouseKeeping);
  const allHotelCompendiumInfo = useSelector(allAmenitiesSelector);
  const allOffersInfo = useSelector(offerSelector);

  const upperCaseName = (value) => {
    return `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
  };

  const dataMap = {
    IRD: inRoomDiningMenu,
    RESTAURANT: allRestaurants,
    SPA: allSpaInfo,
    SERVICE_REQUEST: allServiceRequestInfo,
    HOTEL_COMPENDIUM: allHotelCompendiumInfo,
    ACCOMMODATION: allAccomodationCategories,
    FEEDBACK: [],
    OFFERS: allOffersInfo,
    'CHECK IN': [],
    'DIGITAL KEY': [],
    GRMS: [],
    LOYALTY: [],
    HOTEL_INFO: [],
  };

  const setType = (cta) => {
    if (cta.emailId) return cta.emailId;
    if (cta.phoneNumber) return cta.phoneNumber;
    if (cta.redirectTo) return cta.redirectTo;
  };

  useEffect(() => {
    let tempImage = [];
    if (
      offer?.offerCardType === 'SCRATCH_CARD' &&
      offer?.preScratchImages &&
      !isEmpty(offer?.preScratchImages[0]?.master)
    ) {
      tempImage.push(offer?.preScratchImages[0]);
    }
    if (
      offer?.offerCardType === 'SCRATCH_CARD' &&
      offer?.postScratchImages &&
      !isEmpty(offer?.postScratchImages[0]?.master)
    ) {
      tempImage.push(offer?.postScratchImages[0]);
    }

    if (
      offer?.offerCardType === 'POPUP_CARD' &&
      offer?.popUpImages &&
      !isEmpty(offer?.popUpImages[0]?.master)
    ) {
      tempImage.push(offer?.popUpImages[0]);
    }

    setImage(tempImage);
  }, [offer]);

const collectImages = (offer) => ([
  ...(offer?.preScratchImages || []),
  ...(offer?.postScratchImages || []),
  ...(offer?.popUpImages || []),
].filter(it => it && it.master));

  return (
    <div className='row mx-4 mt-4'>
      {tabValue === 0 && (
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Offer card name</div>
            <div className='details-value preview-breaks'>{offer?.offerCardName}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Offer</div>
            <div className='details-value'>{offer?.offerName}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Offer card type</div>
            <div className='details-value'>{offer?.type}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Offer Recipient</div>
            <div className='details-value'>{offer?.recipient}</div>
          </div>

          {offer?.customAttributes &&
            offer?.customAttributes?.length > 0 &&
            offer?.customAttributes?.map((item, index) => (
              <div key={index} className='col-md-6 mt-4'>
                <div className='details-label'>{item.key}</div>
                <div className='details-value'>{item.value}</div>
              </div>
            ))}
        </>
      )}
      {tabValue === 1 && (
        <>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>CTA</div>
            {offer?.CTA?.status === 'Inactive' && <div className='details-value'>Inactive</div>}
            {offer?.CTA?.status !== 'Inactive' && (
              <div className='details-value'>{upperCaseName(offer?.CTA?.type)}</div>
            )}
          </div>
          {offer?.CTA?.type !== 'OK' && offer?.CTA?.status !== 'Inactive' && (
            <>
              {offer?.CTA?.type === 'ENQUIRE' && (
                <>
                  <div className='col-md-6 mt-4'>
                    <div className='details-label'>Email</div>
                    <div className='details-value'>{offer?.CTA?.emailId || '---'}</div>
                  </div>
                  <div className='col-md-6 mt-4'>
                    <div className='details-label mt-2'>Phone</div>
                    <div className='details-value'>
                      {offer?.CTA?.phoneNumber ? (
                        <CustomPhoneNoView value={offer?.CTA?.phoneNumber} />
                      ) : (
                        '---'
                      )}
                    </div>
                  </div>
                </>
              )}

              {offer.CTA.type === 'REDEEM' && (
                <>
                  <div className='col-md-6 mt-4'>
                    <div className='details-label'>Redirect option</div>
                    <div className='details-value'>{setType(offer.CTA)}</div>
                  </div>
                  {offer?.CTA?.redirectTo === 'EXTERNAL URL' && (
                    <div className='col-md-12 mt-4'>
                      <div className='details-label'>Redirect URL</div>
                      <div className='details-value'>
                        <RedirectUrlLink url={offer.CTA.URL} />
                      </div>
                    </div>
                  )}
                  {offer?.CTA?.redirectTo === 'MODULE' && (
                    <div className='col-md-12 mt-4'>
                      <div className='details-label'>Module</div>
                      <div className='details-value'>{offer.CTA.redirectData}</div>
                    </div>
                  )}
                  {offer?.CTA?.redirectTo === 'FLOW' && (
                    <div className='col-md-12 mt-4'>
                      <div className='details-label'>Flow</div>
                      <div className='details-value'>{offer.CTA.redirectData}</div>
                    </div>
                  )}
                  {offer?.CTA?.redirectTo === 'IN-APP PAGE' && (
                    <div className='col-md-12 mt-4'>
                      <div className='details-label'>In-App Page Flow</div>
                      <div className='details-value'>
                        {allUIBuilderPages?.find((item) => item?.id === offer.CTA.redirectData)
                          ?.name || ''}
                      </div>
                    </div>
                  )}

                  {offer?.CTA?.redirectTo === 'MODULE' && (
                    <div className='col-md-12 mt-4'>
                      <div className='details-label'>
                        {modulesWithoutSubModule.find(({ id }) => id === offer?.CTA?.redirectData)
                          ?.name ?? formattedDetailsLabelData(offer?.CTA?.redirectData)}
                      </div>
                      <div className='details-value'>
                        {dataMap[offer?.CTA?.redirectData]?.find(
                          (item) => item?.id === offer?.CTA?.moduleId,
                        )?.[offer?.CTA?.redirectData === 'FEEDBACK' ? 'pageTitle' : 'name'] ||
                          EMPTY_PLACEHOLDER}
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
          {offer?.CTA?.status !== 'Inactive' && (
            <div className='col-md-12 mt-4'>
              <div className='details-label'>Offer Card Placement Type</div>
              <div className='details-value'>
                {offer?.CTA?.cardPlacementType === 'MODULE'
                  ? 'Module'
                  : offer?.CTA?.cardPlacementType === 'UI_BUILDER_PAGES'
                  ? 'UI Builder Pages'
                  : '---'}
              </div>
            </div>
          )}

          {offer?.CTA?.status !== 'Inactive' && offer?.CTA?.cardPlacementType === 'MODULE' && (
            <div className='col-md-12 mt-4'>
              <div className='details-label'>Module</div>
              <div className='details-value'>
                {offer.CTA.cardPlacement.length > 0
                  ? offer.CTA.cardPlacement
                      .map(
                        (e) => CTA_CARD_PLACEMENT_MODULE_LIST?.find((item) => item?.id === e)?.name,
                      )
                      .join(', ')
                  : '---'}
              </div>
            </div>
          )}

          {offer?.CTA?.status !== 'Inactive' &&
            offer?.CTA?.cardPlacementType === 'UI_BUILDER_PAGES' && (
              <div className='col-md-12 mt-4'>
                <div className='details-label'>UI Builder Pages</div>
                <div className='details-value'>
                  {offer.CTA.cardPlacement.length > 0
                    ? offer.CTA.cardPlacement
                        .map(
                          (e) =>
                            allUIBuilderPages?.find(
                              (item) => item.status === 'Published' && item?.id === e,
                            )?.name,
                        )
                        .filter((item) => item)
                        .join(', ')
                    : '---'}
                </div>
              </div>
            )}
        </>
      )}
      {tabValue === 2 && (
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Schedule type</div>
            <div className='details-value'>
              {offer.schedule?.scheduleType === 'RECURRING'
                ? 'Recurring'
                : offer.schedule?.scheduleType === 'ONE_TIME'
                ? 'One Time'
                : 'Always Active'}
            </div>

            {offer.schedule?.scheduleType === 'RECURRING' && (
              <>
                <div className='col-md-6 mt-4'>
                  <div className='details-label'>Start Date</div>
                  <div className='details-value'>
                    {moment(offer.schedule?.recurring?.startDate, 'DD-MM-YYYY').format(
                      'DD MMM, YYYY',
                    )}
                  </div>
                </div>
                <div className='col-md-6 mt-4'>
                  <div className='details-label'>End Date</div>
                  <div className='details-value'>
                    {moment(offer.schedule?.recurring?.endDate, 'DD-MM-YYYY').format(
                      'DD MMM, YYYY',
                    )}
                  </div>
                </div>
                <div className='col-md-6 mt-4'>
                  <div className='details-label'>Recurs Every</div>
                  <div className='details-value'>
                    {upperCaseName(offer.schedule?.recurring?.recurs || '')}
                  </div>
                </div>
                {offer?.schedule?.recurring?.recursTime ? (
                  <div className='col-md-6 mt-4'>
                    <div className='details-label'>Recurs At</div>
                    <div className='details-value'>
                      {moment(offer.schedule?.recurring?.recursTime, 'HH:mm').format(
                        TIME_FORMAT_12_HOUR,
                      )}
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {offer.schedule?.recurring?.recurs === 'MONTH' && (
                  <div className='col-md-6 mt-4'>
                    <div className='details-label'>Dates</div>
                    <div className='details-value'>{offer.schedule?.recurring?.dates || ''}</div>
                  </div>
                )}
                {offer.schedule?.recurring?.recurs === 'WEEK' && (
                  <div className='col-md-6 mt-4'>
                    <div className='details-label'>Days</div>
                    <div className='details-value'>
                      {offer.schedule?.recurring?.recursWeek?.toString() || ''}
                    </div>
                  </div>
                )}
              </>
            )}
            {offer.schedule?.scheduleType === 'ONE_TIME' && (
              <>
                <div className='col-md-6 mt-4'>
                  <div className='details-label'>Date</div>
                  <div className='details-value'>
                    {moment(offer.schedule?.oneTime?.date, 'DD-MM-YYYY').format('DD MMM, YYYY')}
                  </div>
                </div>
                <div className='col-md-6 mt-4'>
                  <div className='details-label'>Time </div>
                  <div className='details-value'>
                    {moment(
                      `${offer.schedule?.oneTime?.date} ${
                        offer.schedule?.oneTime?.time ? offer.schedule?.oneTime?.time : '00:00'
                      }`,
                      'DD-MM-YYYY HH:mm',
                    ).format(TIME_FORMAT_12_HOUR)}
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}

      {tabValue === 3 && (
        <MediaViewer
          images={collectImages(offer)}
          videos={offer?.videos}
          gifs={offer?.gifs}
          enabledMediaTabs={['image']}
        />
      )}
    </div>
  );
};

export default OfferCardDetails;
